// noinspection ExceptionCaughtLocallyJS

import * as constants from '../constants';
import { ACTION, setLoading, wrap } from './index';
import { Dispatch } from 'redux';
import {
  SchemaAddToBasketRequestBody,
  SchemaGetPriceForProductQueryParams,
  SchemaGetProductAvailabilityQueryParams,
  SchemaGetShareOfTimeQueryParams,
  SchemaPostProductChangeDateRequestBody,
  SchemaPostProductRequestBody,
  SchemaRemoveFromBasketRequestBody,
} from '@repo/legacy-commerce-api';
import legacyApi from '../middlewares/api';

export const postSelect = (payload: SchemaPostProductRequestBody) =>
  wrap(async (dispatch: Dispatch) => {
    try {
      dispatch(setLoading(true));
      dispatch(setLoading({ name: 'productsPost', value: true }));

      const { data, error } = await legacyApi.POST('/select', { body: payload });

      if (error) {
        throw JSON.stringify(error);
      }

      dispatch({ type: constants.POST_SELECT, payload: data });

      return data;
    } catch (err) {
      console.error('error: ', err);
      dispatch(setLoading(false));
      dispatch(setLoading({ name: 'productsPost', value: false }));
      throw err;
    } finally {
      dispatch(setLoading(false));
      dispatch(setLoading({ name: 'productsPost', value: false }));
    }
  }, 'POST_ERROR');

// Unused Action:
export const addToBasket = (payload: SchemaAddToBasketRequestBody) =>
  wrap(async (dispatch: Dispatch) => {
    try {
      dispatch(setLoading(true));

      const { data, error } = await legacyApi.POST('/addtobasket', { body: payload });

      if (error) {
        throw JSON.stringify(error);
      }

      dispatch({ type: constants.ADDED_TO_BASKET, payload: data });
      return data;
    } catch (err) {
      console.error('error: ', err);
      dispatch(setLoading(false));
      throw err;
    }
  }, 'POST_ERROR');

// Unused Action:
export const removeFromBasket = (payload: SchemaRemoveFromBasketRequestBody, urn: string) =>
  wrap(async (dispatch: Dispatch) => {
    try {
      dispatch(setLoading(true));

      const { data, error } = await legacyApi.POST('/removefrombasket', { body: payload });

      if (error) {
        throw JSON.stringify(error);
      }

      dispatch({
        type: constants.REMOVED_FROM_BASKET,
        payload: { ...data, urn },
      });
      return data;
    } catch (err) {
      console.error('error: ', err);
      dispatch(setLoading(false));
      throw err;
    }
  }, 'POST_ERROR');

export const changeProductDate = (payload: SchemaPostProductChangeDateRequestBody) =>
  wrap(async (dispatch: Dispatch) => {
    try {
      dispatch(setLoading(true));

      const { data, error } = await legacyApi.POST('/changedatebasketentry', { body: payload });

      if (error) {
        throw JSON.stringify(error);
      }

      dispatch({ type: constants.CHANGED_PRODUCT_DATE, payload: data });
      return data;
    } catch (err) {
      console.error('error: ', err);
      dispatch(setLoading(false));
      throw err;
    } finally {
      dispatch(setLoading(false));
    }
  }, 'POST_ERROR');

export const getPriceForProduct = (params: SchemaGetPriceForProductQueryParams) =>
  wrap(async (dispatch: Dispatch) => {
    try {
      dispatch(
        setLoading({
          value: true,
          name: 'priceForProduct',
        }),
      );

      const { data, error } = await legacyApi.GET('/priceforproduct', { params: { query: params } });

      if (error) {
        throw JSON.stringify(error);
      }

      dispatch({
        type: constants.FETCHED_PRODUCT_PRICE,
        payload: {
          ...data,
          timeslot: params.timeslot,
        },
      });

      return data;
    } catch (err) {
      console.error('error: ', err);
      dispatch(
        setLoading({
          value: false,
          name: 'priceForProduct',
        }),
      );
      throw err;
    } finally {
      dispatch(
        setLoading({
          value: false,
          name: 'priceForProduct',
        }),
      );
    }
  }, 'POST_ERROR');

export const getPriceForProductNoStateUpdate = (params: SchemaGetPriceForProductQueryParams) =>
  wrap(async (dispatch: Dispatch) => {
    try {
      dispatch(
        setLoading({
          value: true,
          name: 'priceForProduct',
        }),
      );

      const { data, error } = await legacyApi.GET('/priceforproduct', { params: { query: params } });

      if (error) {
        throw JSON.stringify(error);
      }

      return data;
    } catch (err) {
      console.error('error: ', err);
      dispatch(
        setLoading({
          value: false,
          name: 'priceForProduct',
        }),
      );
      throw err;
    } finally {
      dispatch(
        setLoading({
          value: false,
          name: 'priceForProduct',
        }),
      );
    }
  }, 'POST_ERROR');

export const getAvailabilityForDigitalProduct = (params: SchemaGetProductAvailabilityQueryParams) =>
  wrap(async (dispatch: Dispatch) => {
    try {
      dispatch(
        setLoading({
          value: true,
          name: 'calendar',
        }),
      );

      const { data, error } = await legacyApi.GET('/digitalavailability', { params: { query: params } });

      if (error) {
        throw JSON.stringify(error);
      }

      dispatch({
        type: constants.FETCHED_DIGITAL_PRODUCT_AVAILABILITY,
        payload: data,
      });

      return data;
    } catch (err) {
      console.error('error: ', err);
      dispatch(
        setLoading({
          value: false,
          name: 'calendar',
        }),
      );
      throw err;
    } finally {
      dispatch(
        setLoading({
          value: false,
          name: 'calendar',
        }),
      );
    }
  }, constants.FETCH_ERROR);

export const getAvailabilityForDigitalProductNoStateUpdate = (params: SchemaGetProductAvailabilityQueryParams) =>
  wrap(async (dispatch: Dispatch) => {
    try {
      dispatch(
        setLoading({
          value: true,
          name: 'calendar',
        }),
      );

      const { data, error } = await legacyApi.GET('/digitalavailability', { params: { query: params } });

      if (error) {
        throw JSON.stringify(error);
      }

      return data;
    } catch (err) {
      console.error('error: ', err);
      dispatch(
        setLoading({
          value: false,
          name: 'calendar',
        }),
      );
      throw err;
    } finally {
      dispatch(
        setLoading({
          value: false,
          name: 'calendar',
        }),
      );
    }
  }, constants.FETCH_ERROR);

export const getShareOfTime = (params: SchemaGetShareOfTimeQueryParams) =>
  wrap(async (dispatch: Dispatch) => {
    try {
      dispatch(
        setLoading({
          value: true,
          name: 'priceForProduct',
        }),
      );

      const { data, error } = await legacyApi.GET('/calculateshareoftime', { params: { query: params } });

      if (error) {
        throw JSON.stringify(error);
      }

      dispatch({ type: constants.FETCHED_SHARE_OF_TIME, payload: data });
      return data;
    } catch (err) {
      console.error('error: ', err);
      dispatch(
        setLoading({
          value: false,
          name: 'priceForProduct',
        }),
      );
      throw err;
    } finally {
      dispatch(
        setLoading({
          value: false,
          name: 'priceForProduct',
        }),
      );
    }
  }, constants.FETCH_ERROR);

export const updateAttributes = (payload: any): ACTION => ({
  type: constants.UPDATE_ATTRIBUTES2,
  payload,
});
export const resetAttributes = (payload: object): ACTION => ({
  type: constants.RESET_ATTRIBUTES2,
  payload,
});
export const updateDateAndDuration = (payload: {
  startdate: string;
  duration: number;
  producturn: string;
}): ACTION => ({
  type: constants.UPDATE_DATE_DURATION,
  payload,
});

export const setBasketInfo = (payload: { basket: string; basketreference: string }): ACTION => ({
  type: constants.SET_BASKET_INFO,
  payload,
});
